import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';

const Login = ({ onLogin, language, onLanguageChange, messages }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post('/robot-control/api/login', {
        username,
        password
      });

      onLogin(response.data.token);
    } catch (err) {
      setError(`${messages.invalidCredentials} ${err}`);
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="language-switch login-language-switch" aria-label={messages.language}>
          <button
            type="button"
            className={language === 'ru' ? 'active' : ''}
            onClick={() => onLanguageChange('ru')}
          >
            RU
          </button>
          <button
            type="button"
            className={language === 'en' ? 'active' : ''}
            onClick={() => onLanguageChange('en')}
          >
            EN
          </button>
        </div>
        <h2>{messages.loginTitle}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              placeholder={messages.username}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder={messages.password}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={loading} className="login-button">
            {loading ? messages.loggingIn : messages.login}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
